import { render, staticRenderFns } from "./ToggleData.vue?vue&type=template&id=1ffd6454&scoped=true&"
import script from "./ToggleData.vue?vue&type=script&lang=js&"
export * from "./ToggleData.vue?vue&type=script&lang=js&"
import style0 from "./ToggleData.vue?vue&type=style&index=0&id=1ffd6454&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffd6454",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VBtnToggle } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {VBtn,VBtnToggle,VIcon})
